// @ts-check
import {clone, pluck, flatten, both, complement, anyPass, propEq, contains, filter, find, head, match, pipe, prop} from 'ramda'
import Debug from 'debug'
import { empty } from '@bluecrew/bluecrew-lib'
import moment from 'moment-timezone'
const debug = Debug('app:workforce:worker:ctrl')
import JSEncrypt from 'jsencrypt'
import selectCrewCtrl from '../../workforce/select-crew/selectCrew.ctrl'
import selectCrewTpl from '../../workforce/select-crew/selectCrew.html'
import skillsTemplate from '../skills/skills.html'
import { SkillsController } from '../skills/skills.ctrl'
import regionTemplate from './regionTemplate.html'
import paylocityTemplate from './paylocity.html'
import '../../resume/resume.css'
import ratingController from '../../workforce/rating/controller'
import ratingTemplate from '../../workforce/rating/template.html'
import paystubTemplate from '../../profile-webview/paystub/paystub.html'
import paystubController from '../../profile-webview/paystub/paystub.ctrl.js'
import groupMessageController from '../message/groupMessage.ctrl'
import groupMessage from '../message/groupMessage.html'
import showI9DocsController from '../showI9Docs/showI9Docs.crtl'
import showI9DocsTemplate from '../showI9Docs/showI9Docs.html'
import { CertQualificationUtils } from "../../../shared/certQualificationUtils";
import { getWorkerCertifications, getWorkerHealthCertifications } from '../../../component-templates/certification-badge/utils.js'

const workerStatuses = {
  'STARTED_SIGN_UP': {class: 'default', description: 'Signed Up', showInDropdown: true},
  'ELIGIBLE': {class: 'success', description: 'Eligible', showInDropdown: true},
  'PASSED_INTERVIEW': {class: 'primary', description: 'Passed Interview', showInDropdown: true},
  'PENDING': {class: 'rose', description: 'Pending', showInDropdown: true},
  'SUSPENDED': {class: 'warning', description: 'Suspended', showInDropdown: true},
  'FIRED': {class: 'danger', description: 'Fired', showInDropdown: true},
  'FAILED_INTERVIEW': {class: 'danger', description: 'Failed Interview', showInDropdown: true},
  'FOLLOW_UP_INTERVIEW': {class: 'primary', description: 'Needs Interview', showInDropdown: true},
  'SIGNED_CONTRACT': {class: 'rose', description: 'Sign Contract', showInDropdown: true},
  'ELIGIBLE_EOR': {class: 'passive', description: 'EOR', showInDropdown: true},
  'NO_SHOW_INTERVIEW': {class: 'dark', description: 'No Show Interview', showInDropdown: true},
  'NEEDS_I9': {class: 'primary', description: 'Needs I9', showInDropdown: true},
  'ENTERED_GENERAL_INFO': {class: 'rose', description: 'Entered General Info', showInDropdown: false},
  'ENTERED_BACKGROUND_CHECK_INFO': {class: 'rose', description: 'Entered Background Check', showInDropdown: false},
  'RUNNING_BACKGROUND_CHECK': {class: 'passive', description: 'Running Checkr', showInDropdown: false},
  'ENTERED_TAX_INFO': {class: 'passive', description: 'Entered Tax Info', showInDropdown: false},
  'DOUBLE_PROFILE': {class: 'dark', description: 'Duplicate Account', showInDropdown: false},
  'PAUSED_PROFILE': {class: 'dark', description: 'Paused', showInDropdown: false},
  'FAILED_BACKGROUND_CHECK': {class: 'danger', description: 'Failed Background', showInDropdown: true},
  'NEEDS_CREWMEMBER_I9': {class: 'primary', description: 'Agent Selection', showInDropdown: false},
  'NEEDS_I9_AGENT': {class: 'primary', description: 'Needs I9 Agent', showInDropdown: false},
  'INACTIVE': {class: 'dark', description: 'Inactive', showInDropdown: false},
}

export class WorkerController {
  /* @ngInject */
  constructor (
    $scope,
    Users,
    Crews,
    Auth,
    NgMap,
    ReferenceService,
    ToastService,
    worker,
    Jobs,
    $mdToast,
    $mdDialog,
    $state,
    $rootScope,
    notes,
    inModal,
    application,
    jobTypes,
    skills,
    company,
    $window,
    $q,
    PayrollService,
    Paystub,
    PaylocityService,
    /** @type {import('../../../shared/users').UsersModule} */
    UsersService,
  ) {
    this.NgMap = NgMap
    this.ToastService = ToastService
    this.PayrollService = PayrollService
    this.Crews = Crews
    this.worker = worker
    this.editedWorker = this.cloneWorker(worker)

    Auth.getDetails()
    .then(user => {
      this.user = user
    })

    this.Auth = Auth

    ReferenceService.getRegions()
    .then(result => {
      this.regions = result

      if (this.worker.region_id) {
        const region = find(propEq('id', this.worker.region_id), this.regions)
        this.regionPolygonCoordinates = region.polygon_coordinates
      }
    })
    this.$scope = $scope
    debug(application)
    this.application = application

    this.Jobs = Jobs
    this.$window = $window
    this.workerStatuses = workerStatuses
    this.$q = $q
    this.degrees = 0
    this.isReview = 0
    this.crews = this.Crews.getCrews()
    if (this.application.workHistory) {
      this.workHistory = this.application.workHistory
    }
    if (this.application.applicationAnswers) {
      // this.application.applicationAnswers.forEach((question) => this.stringReplace(question))
      this.applicationAnswers = this.application.applicationAnswers
    }
    var levelsEnum = {
      0: 'Recruit',
      1: 'Certified',
      2: 'Elite',
      3: 'Champion',
      4: 'Hall of Famer'
    }
    this.sites = {
      'UNKNOWN': '',
      'SINGLE': 'at a single job site',
      'MULTIPLE': 'at a variety of job sites'
    }
    var levelsColor = {
      0: '#D7D7D9',
      1: '#526069',
      2: 'c1dbdf',
      3: '87c3cc',
      4: '#eaad61'
    }
    this.notes = notes
    this.worker.level = levelsEnum[this.worker.level]
    this.worker.color = levelsColor[this.worker.level]
    this.bioLimit = 100
    this.$state = $state
    this.worker.company_rating = filter(propEq('company_id', company.id), this.worker.ratings)
    this.worker.averageRating = head(worker.ratings.slice(-1))
    this.Users = Users
    this.favorites = filter(x => x.favorite === 1, this.worker.ratings)
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog
    this.$rootScope = $rootScope
    this.inModal = inModal
    this.jobTypes = jobTypes
    this.adminEditToggle = true
    this.adminEditStatus = true
    this.profileIsEdited = false
    this.showdetailView = false
    this.showHiringDetails = false
    this.workHistoyLimit = 4
    if (this.$state.includes('app.applicants.applicant') || this.$state.includes('app.applicant')) {
      this.applicantRoute = true
    }

    this.setRatingStars()
    this.ratingsDetail
    this.jobSentActivity
    this.timeline
    this.workerLocationText = this.getAddrString(this.worker)
    this.selectedPlace = ''
    this.hardSetRegionId = this.worker.region_id
    this.regionMapError
    this.UsersService = UsersService;

    this.userCertifications = []
    this.refreshUserCertifications()
    this.Paystub = Paystub
    this.PaylocityService = PaylocityService
    this.ssn = ''
    this.worker.isVaccinated = (this.worker.covid_vaccination_response === "YES" || this.worker.covid_vaccination_date !== null)
    this.hasGoogleAutosuggestion = true
    this.addToWorkforceId = null
  }

  refreshUserCertifications() {
    this.userCertifications = []

    this.userCertifications.push(...getWorkerCertifications(this.worker))
    this.Users.getCertificationsAdmin(this.worker.external_id).then(
      ([certifications, _drugScreenCertifications]) => {
        const filteredCertifications = CertQualificationUtils.filterLegacyCerts(certifications);
        this.userCertifications.push(
          ...CertQualificationUtils.formatCertifications(filteredCertifications)
        );
      }
    );

    this.userCertifications.push(...getWorkerHealthCertifications(this.worker));

    this.UsersService.getUserQualifications(this.worker.external_id).then((qualifications) => {
      if (qualifications.length === 0) return;
      this.userCertifications.push(
        ...CertQualificationUtils.formatUserQualificationsToCerts(qualifications)
      );
    });
  }

  cloneWorker(worker) {
    let workerCopy = clone(worker)
    // covid exemption checkbox ng-model does not work on truthy, needs to be a boolean value
    workerCopy.is_covid_exempt = worker.is_covid_exempt ? true : false
    workerCopy.is_eb_i9_verified = worker.is_eb_i9_verified ? true : false
    return workerCopy
  }

  setRatingStars () {
    if (this.worker.rating == null) {
      this.worker.rating = 0
    }
    this.fullStars = Math.floor(this.worker.rating)
    this.halfStar = this.worker.rating - this.fullStars >= 0.5
    this.emptyStars = this.halfStar ? 5 - this.fullStars - 1 : 5 - this.fullStars
  }

  selectCrew ($ev) {
    const crews = this.crews

    return this.$mdDialog.show({
      controller: selectCrewCtrl,
      controllerAs: 'wcr',
      template: selectCrewTpl,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        crews
      }
    })
  }

  stringReplace (question) {
    question = question.map((string) => {
      string = string.replace('${recruiter_name}', this.recruiterInfo.name)
      string = string.replace(/0X[0-9a-f]{5}/i, (_, key) => {
        let unicode = _
        return String.fromCodePoint(unicode)
      })

      return string
    })
    return question
  }

  removeMark ($event, rating, isFave, userExternalId) {
    const ratingLabelText = isFave ? 'Favorite' : "Don't Send Back"

    let confirm = this.$mdDialog.confirm()
      .title('Remove Rating')
      .textContent(`Do you want to remove the ${ratingLabelText} rating for ${this.worker.first_name}?`)
      .ariaLabel('Remove Rating Label')
      .targetEvent($event)
      .ok('Confirm')
      .cancel('Cancel')

    this.$mdDialog.show(confirm)
    .then(() => {
      this.Users.removeMark({markId: rating, isFave: isFave, userExternalId: userExternalId})
      .then(() => {
        const msg = `${ratingLabelText} Removed`
        this.$mdToast.showSimple(msg)
        $($event.target).hide();
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple('Failed To Update Profile Info')
      })
    })
  }

  close () {
    this.$mdDialog.hide()
  }

  showSkillsDialog () {
    this.$mdDialog.show({
      parent: document.body,
      multiple: true,
      clickOutsideToClose: true,
      template: skillsTemplate,
      controller: SkillsController,
      controllerAs: 'ctrl',
      locals: {
        user: this.user,
        worker: this.worker
      }
    })
    .then(verifiedSkills => {
      this.worker.verifiedSkills = verifiedSkills
      this.refreshUserCertifications()
    })
    .catch(() => {})
  }

  getLegacyI9 (id) {
    this.downloadLoader = true
    this.Users.getLegacyI9(id)
      .then((res) => {
        let file = new Blob([res.data], {type: 'application/pdf'})
        let fileName = `${this.worker.first_name}_${this.worker.last_name}`
        let fileURL = URL.createObjectURL(file)
        let a = document.createElement('a')
        a.href = fileURL
        a.target = '_blank'
        a.download = fileName + '.pdf'
        document.body.appendChild(a)
        a.click()
        this.downloadLoader = false
      })
      .catch((err) => {
        this.downloadLoader = false
        return this.ToastService.showWarning(err)
      })
  }

  showRatingDialog () {
    this.$mdDialog.show({
      parent: document.body,
      template: ratingTemplate,
      multiple: true,
      fullscreen: true,
      locals: {
        worker: this.worker
      },
      controller: ratingController,
      controllerAs: 'ctrl'
    })
    .then(rating => {
      this.worker.rating = rating
      this.setRatingStars()
    })
    .catch(() => {})
  }

  addNoteSuccess () {
    this.$mdToast.showSimple('Note added.')
    var now = moment.utc().format()

    this.notes.unshift({
      note: this.currNote,
      created_at: now
    })
    this.currNote = ''
  }

  addNoteError (err) {
    if (!err) return
    this.$mdToast.showSimple('Unable to add note.')
  }

  addNote (ev) {
    let confirm = this.$mdDialog.prompt()
      .title('Add Note')
      .textContent('Notes are for your internal team\'s use and are not visible to workers')
      .ariaLabel('Add Note')
      .targetEvent(ev)
      .multiple(true)
      .ok('OK')
      .cancel('Cancel')

    this.$mdDialog.show(confirm)
      .then(note => {
        this.currNote = note
        return this.Users.addNote(this.worker.external_id, note)
      })
      .then(this.addNoteSuccess.bind(this), this.addNoteError.bind(this))
  }

  rate (rating) {
    let userIds = [this.worker.external_id]
    let confirm = this.$mdDialog.confirm()
      .title(`Confirm Your Rating of ${this.worker.first_name}`)
      // .textContent(`Leave an optional review of ${this.worker.first_name} below:`)
      .ariaLabel('Add Review')
      .ok('OK')
      .multiple(true)
      .cancel('Cancel')
    this.$mdDialog.show(confirm)
    .then(note => {
      if (note.length) { this.Users.addNote(this.worker.external_id, note, this.isReview) }
      this.Users.rate(rating, userIds)
      .then(() => {
        let word = (userIds.length > 1) ? 'users' : 'user'
        const msg = `${userIds.length} ${word} rated!`
        this.$mdToast.showSimple(msg)
        this.updateWorkforce()
      })
    })
    .catch((err) => {
      if (!err) return
      this.$mdToast.showSimple('Unable to rate worker')
    })
  }

  favorite (worker) {
    let userIds = [this.worker.external_id]

    this.Users.favorite(userIds)
      .then((res) => {
        let word = (userIds.length > 1) ? 'users' : 'user'
        const msg = `${userIds.length} ${word} added to favorites!`
        this.$mdToast.showSimple(msg)
        this.$rootScope.$broadcast('deselectAll')
        this.updateWorkforce()
      })
      .catch(this.favError)
  }

  unfavorite (worker) {
    let userIds = [this.worker.external_id]

    this.Users.unfavorite(userIds)
      .then((res) => {
        let word = (userIds.length > 1) ? 'users' : 'user'
        const msg = `${userIds.length} ${word} removed from favorites.`
        this.$mdToast.showSimple(msg)
        this.$rootScope.$broadcast('deselectAll')
        this.updateWorkforce()
      })
      .catch(this.unfavError)
  }

  updateWorkforce () {
    this.Users.getWorkforce()
      .then(wf => {
        this.workforce = wf
        this.unrated = this.Users.getUnrated()
        this.favorites = this.Users.getFavorites()
        this.nosends = this.Users.getNosends()
      })
  }

  directHire () {
    this.$state.go('app.jobCreate', { directlyInvitedWorkers: [this.worker] })
  }

  addToCrew () {
    let userIds = [this.worker.external_id]
    debug('adding the following users to crew: %o', userIds)

    this.selectCrew()
      .then(x => this.Crews.addUsersToCrew(userIds), err => { throw err })
      .then((res) => {
        let word = (userIds.length > 1) ? 'users' : 'user'
        const msg = `${userIds.length} ${word} added to crew.`
        this.$mdToast.showSimple(msg)
        this.$rootScope.$broadcast('deselectAll')
        this.$window.location.reload()
      })
      .catch((e) => {
        if (!e) return

        // User clicked manage joaddNotes on add to crew modal.
        if (e === 'manage') {
          this.$state.go('app.crews')
        }
      })
  }

  concatEventsDontSendWithActivity() {
    this.worker.activity_and_event_dont_send = JSON.parse(JSON.stringify(this.worker.activity)) //deep clone
    if(this.worker.events_dont_send){
      this.worker.events_dont_send.forEach(e => {
        e.status = 'event_dont_send'
        this.worker.activity_and_event_dont_send.push(e)
      })
    }
    this.worker.activity_and_event_dont_send.sort((a,b) => {
      if(a.start_date_time < b.start_date_time){
        return 1
      } else {
        return -1
      }
    })
  }

  getRatings () {
    this.selectedTab = 'ratings'
    this.Users.getRatings(this.worker.external_id)
    .then((data) => {
      this.ratingsDetail = data.WorkerRating
    })
    .catch((err) => {
      if (!err) return
      debug(err)
      this.$mdToast.showSimple('Failed')
    })
  }

  getJobActivity () {
    this.selectedTab = 'activity'
    this.Users.getJobActivity(this.worker.external_id, 'false', 100)
      .then((data) => {
        this.jobSentActivity = data
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple('Failed')
      })
  }

  downloadSentCSV () {
    this.Users.getSentJobsCSV(this.worker.external_id)
      .then((res) => {
        let file = new Blob([res.data], {type: 'application/csv'})
        let fileName = this.worker.first_name
        let fileURL = URL.createObjectURL(file)

        let a = document.createElement('a')
        a.href = fileURL
        a.target = '_blank'
        a.download = fileName + '.csv'
        document.body.appendChild(a)
        a.click()
      })
      .catch(() => {
        return this.$mdToast.showSimple('Sent Jobs Not Available')
      })
  }

  getTimeline () {
    this.selectedTab = 'timeline'
    this.Users.getTimeline(this.worker.external_id)
      .then((data) => {
        this.timeline = data
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple('Failed')
      })
  }

  viewPayHistory () {
    window.open('/app.html#!/pay/user/' + this.worker.external_id, '_blank')
  }

  editProfile () {
    this.originalWorker = clone(this.worker)
    this.workerUpdateForm.$setPristine()
    this.profileIsEdited = true
  }

  cancelEditProfile () {
    this.editedWorker = this.cloneWorker(this.originalWorker)
    this.profileIsEdited = false
  }

  async updateEmployeeInfo () {
    // this is called when we click 'Save' button on UI
    // this.workerUpdateForm.address.$touched || this.workerUpdateForm.apartment.$touched
    if (!this.hasGoogleAutosuggestion) {
      this.editedWorker.address = `${this.editedWorker.streetNumber} ${this.editedWorker.streetName}`
    }

    const getWorkerFieldIfModified = (fieldName) => {
      return (this.editedWorker?.[fieldName] !== this.originalWorker?.[fieldName]
        && this.editedWorker?.[fieldName]) || null
      }

    const isWorkerAddressModified = () => {
      const addressFields = ['address', 'apartment', 'city', 'state', 'zipcode']
      return addressFields.some(fieldName => getWorkerFieldIfModified(fieldName))
    }

    const userProfileInfoModifiedFields = {
      firstName: getWorkerFieldIfModified('first_name'),
      lastName: getWorkerFieldIfModified('last_name'),
      emailAddress: getWorkerFieldIfModified('username'),
      phone: getWorkerFieldIfModified('phone_number')
    }

    const legacyUserProfileInfo = {
      id: this.editedWorker.external_id,
      vensure_id: this.editedWorker.vensure_id,
      everify_case_num: this.editedWorker.everify_case_num,
      is_covid_exempt: this.editedWorker.is_covid_exempt,
      covid_vaccination_date: this.editedWorker.covid_vaccination_date ? new Date(this.editedWorker.covid_vaccination_date).toISOString() : null,
      is_eb_i9_verified: this.editedWorker.is_eb_i9_verified
    }

    let streetAddressLines = []
    let isAddressModified = isWorkerAddressModified()
    if (isAddressModified && this.editedWorker.address) {
      streetAddressLines.push(this.editedWorker.address)
      if (this.editedWorker.apartment) {
        streetAddressLines.push(this.editedWorker.apartment)
      }
    }
    const userAddress = isAddressModified ? {
      streetAddressLines: streetAddressLines,
      city: this.editedWorker.city,
      state: this.editedWorker.state,
      zipcode: this.editedWorker.zipcode
    } : null

    if (this.workerStatusUpdate) {
      userProfileInfoModifiedFields.status = this.editedWorker.status
    }

    // Do not allow fields to be empty
    if (!this.editedWorker.first_name || !this.editedWorker.last_name || !this.editedWorker.username || !this.editedWorker.phone_number) {
      this.ToastService.showWarning('Name, email, and phone number cannot be empty.')
      return
    }

    // Prevent deletion of COVID-19 date
    if (this.originalWorker.covid_vaccination_date && !this.editedWorker.covid_vaccination_date) {
      this.ToastService.showWarning('Cannot delete COVID-19 Vaccination Date. Reach out to CM team if you need to delete.')
      return
    }

    // Prevent deletion of COVID-19 exemption
    if (this.originalWorker.is_covid_exempt && !this.editedWorker.is_covid_exempt) {
      this.ToastService.showWarning('Cannot delete COVID-19 Vaccination Exemption. Reach out to CM team if you need to delete.')
      return
    }

    try {
      await this.Users.updateUserProfileAdmin(this.editedWorker.external_id, userProfileInfoModifiedFields, userAddress)
    } catch (error) {
      if (error.status === 409 && error.data?.details?.toLowerCase().startsWith('username already exists')) {
        this.ToastService.showError(error, 'Unable to update user email! Email already exists for another user.')
      } else {
        this.ToastService.showError(error, 'Unable to update user profile!')
      }
      return
    }

    this.Users.updateEmployeeInfo(legacyUserProfileInfo)
      .then(() => {
        this.worker = clone(this.editedWorker)
        this.ToastService.showSuccess('User updated successfully!')
        this.profileIsEdited = false
      })
      .catch(error => {
        this.ToastService.showError(error, 'Unable to update user!')
      })
  }

  bypassDuplicateSsn() {
      this.Users.bypassDuplicateSsn(this.worker.external_id)
          .then(() => {
            this.ToastService.showSuccess('Successfully bypassed duplicate ssn!')
          })
          .catch(error => this.ToastService.showError(error, 'Unable to bypass duplicate ssn!'))
  }

  getAddrString (worker) {
    if (!worker.address) return ''
    return `${worker.address}, ${worker.city}, ${worker.state}, United States`
  }

  getStreetNumber(address) {
    if (!address) return ''

    const numberMatchResults = address.match(/^(\d+)/)

    return numberMatchResults ? numberMatchResults[1] : ''
  }

  getStreetName(address) {
    if (!address) return ''

    const nameMatchResults = address.match(/^\d+\s+(.+)/)

    return nameMatchResults ? nameMatchResults[1] : ''
  }

  toggleManualAddressEntry() {
    this.hasGoogleAutosuggestion = !this.hasGoogleAutosuggestion
    this.editedWorker.apartment = ''
    this.selectedPlace = ''
    this.editedWorker.streetNumber = this.getStreetNumber(this.editedWorker.address)
    this.editedWorker.streetName = this.getStreetName(this.editedWorker.address)
  }

  queryAddress (input) {
    let def = this.$q.defer()
    let types = [
      'address'
    ]

    this.AutocompleteService = new this.$window.google.maps.places.AutocompleteService()
    this.AutocompleteService.getPlacePredictions({input, types}, (results, status) => {
      if (status !== 'OK') {
        this.workerUpdateForm.address.$invalid = true
        return
      }
      def.resolve(results)
    })
    if (!this.selectedPlace || !this.selectedPlace.place_id) {
      this.workerUpdateForm.address.$error = {selectMatch: true}
      this.workerUpdateForm.address.$invalid = true
    } else {
      this.workerUpdateForm.address.$error = null
      this.workerUpdateForm.address.$invalid = false
    }

    return def.promise
  }

  placeDetails () {
    let options = {
      types: ['address']
    }
    this.PlacesService = new this.$window.google.maps.places.PlacesService(document.getElementById('places-div'))
    debug('modifying worker address.')
    if ((!this.selectedPlace || !this.selectedPlace.place_id)) {
      this.workerUpdateForm.address.$invalid = true
      this.workerUpdateForm.address.$error = {'required': true}
      return
    }
    this.PlacesService.getDetails({placeId: this.selectedPlace.place_id}, (results, status) => {
      if (status !== 'OK') {
        this.workerUpdateForm.address.$invalid = true
        this.workerUpdateForm.address.$error = {'required': true}
        return
      }

      let streetNumber
      let streetName
      let country

      const hasCitySpecified = results.address_components.some(addr => addr.types.includes('locality'));
      // Parse address results from places API. Massage for template endpoint.
      results.address_components.forEach((x) => {
        var type = head(prop('types', x))
        if (type === 'street_number') streetNumber = x.long_name
        if (type === 'route') streetName = x.long_name
        if (type === 'locality') this.editedWorker.city = x.long_name
        // sometimes we don't have city as 'locality'. In such cases let's use 'sublocality_level_1'
        // For example, "The Bronx" in NY.
        else if (!hasCitySpecified && type === 'sublocality_level_1') this.editedWorker.city = x.long_name
        if (type === 'country') country = x.long_name
        if (type === 'administrative_area_level_1') this.editedWorker.state = x.short_name
        if (type === 'postal_code') this.editedWorker.zipcode = x.long_name
      })

      // Ensure address actually has a street number.
      const hasStreet = pipe(
        prop('address_components'),
        pluck('types'),
        flatten,
        both(contains('street_number'), contains('route'))
      )(results)

      const validAddress = complement(anyPass([
        () => empty(streetNumber),
        () => empty(this.editedWorker.city),
        () => empty(country),
        () => empty(this.editedWorker.zipcode),
        () => empty(this.editedWorker.state)
      ]))

      // Weird exception for pier addresses.
      const pier = match(/^pier \d*/i, this.selectedPlace.description)
      if ((!hasStreet && empty(pier)) || !validAddress) {
        this.workerUpdateForm.address.$invalid = true
        this.workerUpdateForm.address.$error = {'required': true}
        return
      }

      this.editedWorker.address = !empty(pier) ? pier[0] : `${streetNumber} ${streetName}`

      this.editedWorker.address_latitude = results.geometry.location.lat()
      this.editedWorker.address_longitude = results.geometry.location.lng()
      this.workerUpdateForm.address.$invalid = false
      this.workerUpdateForm.address.$error = false
    }, options)
  }

  showI9Docs ($event) {
    const parentEl = document.body
    this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: showI9DocsTemplate,
      multiple: true,
      fullscreen: true,
      locals: {
        worker: this.worker
      },
      controller: showI9DocsController,
      controllerAs: 'ctrl'
    })
  }

  showGroupMessage ($event) {
    return this.$mdDialog.show({
      multiple: true,
      targetEvent: $event,
      template: groupMessage,
      locals: {
        users: [this.worker.external_id]
      },
      controller: groupMessageController,
      controllerAs: 'gm'
    })
  }

  async viewOpenJobs () {
    let def = this.$q.defer()
    this.Jobs.fetchOpenJobsData()
      .then((res) => {
        this.openJobs = res.jobsData
        def.resolve(res.jobsData)
      })
    return def.promise
  }

  searchSendJobId (jobId) {
    if (!jobId) {
      this.sendJobId = ''
    } else {
      this.sendJobId = jobId
    }
  }

  selectedSendJobId (job) {
    if (!job) {
      return
    }

    this.sendJobId = job.job_id.toString()
  }

  sendJob (jobId) {
    let userIds = [this.worker.external_id]
    this.Users.sendJob(userIds, jobId)
      .then(() => {
        let word = (userIds.length > 1) ? 'workers' : 'worker'
        const msg = `${userIds.length} ${word} Sent Job`
        this.$mdToast.showSimple(msg)
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple('Unable to send job')
      })
  }

  putOnJob (jobId) {
    let userIds = [this.worker.external_id]
    this.Users.checkOverlap({userIds, jobId})
      .then(() => this.Users.putOnJob([this.worker.external_id], jobId), this.handleOverlap.bind(this))
      .then(() => {
        let word = (userIds.length > 1) ? 'workers' : 'worker'
        const msg = `${userIds.length} ${word} Put On Job`
        this.$mdToast.showSimple(msg)
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        if (err.data && err.data.reason && typeof err.data.reason === 'string' && err.data.reason.trim()) {
          const message = err.data.reason.trim().substring(0, 200)
          this.$mdToast.show(this.$mdToast.simple(message).hideDelay(10000))
        } else {
          this.$mdToast.showSimple(`Unable to Put user On job`)
        }
      })
  }

  handleOverlap (e) {
    if (!e.status || e.status !== 409) throw e
    let text
    let title

    const users = pipe(
      prop('reason'),
      JSON.parse,
      pluck('name')
    )(e.data)

    title = users + ' has a conflicting schedule. Cannot Put on Job!'

    const confirm = this.$mdDialog.alert()
      .title(title)
      .textContent(text)
      .ariaLabel('Conflict Alert')
      .ok('Ok')

    this.$mdDialog.show(confirm);
    return Promise.reject(null);
  }

  getPaystubData () {
    this.PayrollService.getUserPaystub({ userId: this.worker.external_id })
    .then(result => {
      this.paystubs = result
      this.paystubsLoaded = true
    })
    this.Users.getCheckrData(this.worker.checkr_id)
    .then(result => {
      this.checkrData = result
    })
  }

  showPaystub (paystub) {
    const parentEl = document.body
    this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      multiple: true,
      locals: {
        paystub,
        checkrData: this.checkrData || null,
        user: this.worker,
        inModal: true
      },
      template: paystubTemplate,
      controller: paystubController,
      controllerAs: 'w'
    })
  }

  createDmvReport ($event) {
    if (!this.worker.checkr_id) {
      this.ToastService.showWarning('You need to run background report first!')
      return
    }

    let confirm = this.$mdDialog.confirm({multiple: true})
    .title('Checkr Report')
    .textContent(`Are you sure you want to run a check on ${this.worker.first_name}?`)
    .ariaLabel('DMV Check')
    .targetEvent($event)
    .ok('Run')
    .cancel('Cancel')

    this.$mdDialog.show(confirm)
    .then(() => {
      this.Users.runMVRCheck({
        licenseNumber: this.license,
        licenseState: this.stateLicense.toUpperCase(),
        userId: this.worker.id
      })
      .then((id) => {
        this.worker.checkr_dmv_id = id
        this.showDmvReportForm = false
        this.$mdToast.showSimple('Checkr Report Created')
      })
      .catch(result => {
        this.dmvReportError = result.data.reason
      })
    })
  }

  decryptData (encryptedData, key) {
    let crypt = new JSEncrypt()
    crypt.setPrivateKey(key)
    let data = JSON.stringify(JSON.parse(crypt.decrypt(encryptedData)), null, 2)
    this.$mdDialog.show(
      this.$mdDialog.alert()
        .clickOutsideToClose(true)
        .multiple(true)
        .title('User Info')
        .htmlContent(`<pre>${data}</pre>`)
        .ariaLabel('User Info')
        .ok('Close')
    )
  }

  showPaylocityDialog (ev) {
    this.$mdDialog.show({
      template: paylocityTemplate,
      multiple: true,
      scope: this.$scope,
      preserveScope: true,
      targetEvent: ev
    })
  }

  createPaylocityAcc (ssn) {
    const ssnStr = ssn ? `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(5, 9)}` : ''
    this.hidePaylocityDialog()
    this.ToastService.showWarning('Paylocity account creation in progress')
    this.PaylocityService.createPaylocityAccount(this.worker.id, ssnStr)
    .then(() => {
      this.ToastService.showSuccess('Paylocity account created successfully!')
    })
    .catch(error => {
      this.ToastService.showError(error, 'Something went wrong while creating Paylocity account')
    })
  }

  synchronizePaylocityAcc () {
    this.ToastService.showWarning('Paylocity account synchronization in progress')
    this.PaylocityService.synchronizePaylocityAccount(this.worker.id)
    .then(() => {
      this.ToastService.showSuccess('Paylocity account synchronized successfully!')
    })
    .catch(error => {
      this.ToastService.showError(error, 'Something went wrong while synchronizing Paylocity account')
    })
  }

  hidePaylocityDialog () {
    this.$mdDialog.cancel()
    this.ssn = ''
  }

  addUserToWorkforce ($event, companyId) {
    let userId = this.worker.external_id
    let confirm = this.$mdDialog.confirm()
      .title('Add to Workforce')
      .textContent(`Are you sure you want to add ${this.worker.first_name} to this company?`)
      .ariaLabel('Add to workforce')
      .targetEvent($event)
      .ok('Add')
      .cancel('Cancel')

    this.$mdDialog.show(confirm)
      .then(() => { this.Users.addUserToWorkforce({userId, companyId}) })
      .then(() => {
        const msg = 'Worker added to workforce'
        this.$mdToast.showSimple(msg)
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.$mdToast.showSimple('Unable to add user to workforce')
      })
  }

  getEmploymentReport () {
    let userId = this.worker.id
    this.Users.getEmploymentReport(userId)
    .then(() => {
      const msg = 'Email has been sent to you'
      this.$mdToast.showSimple(msg)
    })
    .catch((err) => {
      if (!err) return
      debug(err)
      this.$mdToast.showSimple('Failed To grab employment details')
    })
  }

  showRegionDialog () {
    this.editedAddressLatitude = this.worker.address_latitude
    this.editedAddressLongitude = this.worker.address_longitude
    this.editedRegionId = this.worker.region_id
    this.$mdDialog.show({
      template: regionTemplate,
      multiple: true,
      scope: this.$scope,
      preserveScope: true,
      controller: ['$scope', function DialogController ($scope) {
        $scope.setHardRegionCoords = function (event) {
          const lat = event.latLng.lat()
          const lng = event.latLng.lng()
          $scope.w.editedAddressLatitude = lat
          $scope.w.editedAddressLongitude = lng

          $scope.w.validateRegionContainsLocation()
        }
      }]
    })
  }

  validateRegionContainsLocation () {
    const region = find(propEq('id', this.editedRegionId), this.regions)
    const paths = region.polygon_coordinates.map(c => {
      return new this.$window.google.maps.LatLng(c[0], c[1])
    })
    const polygon = new this.$window.google.maps.Polygon({paths})
    const point = new this.$window.google.maps.LatLng(this.editedAddressLatitude, this.editedAddressLongitude)
    this.regionMapError = this.$window.google.maps.geometry.poly.containsLocation(point, polygon) ? null : 'Please move marker inside the region'
  }

  displayRegion () {
    const region = find(propEq('id', this.editedRegionId), this.regions)
    this.regionPolygonCoordinates = region.polygon_coordinates

    this.NgMap.getMap()
    .then(map => {
      this.$window.google.maps.event.addListenerOnce(map, 'zoom_changed', () => {
        map.setZoom(map.getZoom() - 1)
      })
      const bounds = new this.$window.google.maps.LatLngBounds()
      region.polygon_coordinates.forEach(point => {
        bounds.extend({lat: point[0], lng: point[1]})
        const polygonCenterPoint = bounds.getCenter()
        this.editedAddressLatitude = polygonCenterPoint.lat()
        this.editedAddressLongitude = polygonCenterPoint.lng()
      })
      map.fitBounds(bounds)
    })
  }

  updateRegionAndCoordinates() {
    const region = find(propEq('id', this.editedRegionId), this.regions)

    const userAddress = {
      latitude: this.editedAddressLatitude,
      longitude: this.editedAddressLongitude,
      regionId: this.editedRegionId
    }
    this.Users.updateUserProfileAdmin(this.worker.external_id, {}, userAddress)
      .then(() => {
        this.worker.address_latitude = this.editedAddressLatitude
        this.worker.address_longitude = this.editedAddressLongitude
        this.worker.region_id = this.editedRegionId
        this.worker.region = region.label
        this.$mdToast.showSimple('Updated worker\'s region')
        this.$mdDialog.hide()
      })
  }

  disableDirectDeposit () {
    this.Users.disableDirectDeposit(this.worker.id)
    .then(() => {
      this.worker.hasDirectDeposit = false
      this.$mdToast.showSimple('Direct deposit disabled')
    })
  }

  closeDialog () {
    this.$mdDialog.hide()
  }

  calculateStartDate (date) {
    return this.Paystub.calculateStartDate(date)
  }
}
